<template>
    <modal-ekp modalName="fileModal20" draggable=".window-header" :adaptive="true" :resizable="true" title="Документы" :width="widthDocumentModal"
               v-model="modalDocOpened">
        <div class="d-block">
            <b-tabs content-class="mt-2" small>
                <b-tab title="Документы/Файлы">
                    <FileDocument :apipath="'docEkp/document'" :pathStr="'upload'" :ekp_id="itemId" :nameDoc="'файл'"
                                  :fileType="fileTypes"
                                  :checkDate="true" ref="FileDocuments">
                    </FileDocument>
                </b-tab>
                <b-tab title="Изменения">
                    <FileChange :apipath="'docEkp/change'" :ekp_id="itemId" ref="ChangeDocument"></FileChange>
                </b-tab>
<!--                <b-tab title="Изменения (прошлая версия)">-->
<!--                    <FileDocument :apipath="'docEkp/fileDoc'" :pathStr="'upload'" :ekp_id="itemId" :nameDoc="'изменение'"-->
<!--                                  :checkDate="true" :isCalled="true">-->
<!--                    </FileDocument>-->
<!--                </b-tab>-->
            </b-tabs>
        </div>
        <div class="text-right">
            <b-button class="mt-1 mr-1" size="sm" variant="outline-primary" @click="saveDocsAll()">Сохранить</b-button>
            <b-button class="mt-1" size="sm" variant="outline-danger" @click="closeModal()">Закрыть</b-button>
        </div>
    </modal-ekp>
</template>

<script>
    import FileDocument from '../../components/FileDocument.vue'
    import FileChange from '../../components/FileChange.vue'
    import ModalEkp from './ModalFormEkp'
    import global from "../../utils/global";

    export default {
        name: "DocumentsEkp",
        components: {FileDocument, FileChange, ModalEkp},
        props: {
            itemId: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                fileTypes: '.pdf,.xls,.xlsx,.doc,.docx',
                widthDocumentModal: '70%',
                modalDocOpened: false
            }
        },
        created() {
            this.onResize();
        },
        methods: {
            onResize() {
                if (document.documentElement.clientWidth > global.isMobileWidth()) {
                    this.widthDocumentModal = '70%'
                } else {
                    this.widthDocumentModal = '90%'
                }
            },
            saveDocsAll() {
                this.saveDocsEkp();
                this.saveDocuments();
                this.closeModal();
            },
            saveDocsEkp() {
                this.$refs.ChangeDocument.saveChangesEkp();
            },
            saveDocuments() {
                this.$refs.FileDocuments.saveDocuments();
            },
            closeModal() {
                this.modalDocOpened = false
            },
            openModal() {
                console.log(this.itemId)
                this.modalDocOpened = true
            }
        }
    }
</script>

